export default __webpack_public_path__ + "static/media/loading.02151517.svg";